import history from '../history';
import { Modal } from 'antd';
import { LocalstorageService } from "../services/localstorage-service";
import { narAppStorageKey } from "../constants/session-storage/auth";

const defaulHeaders = {
  'Content-Type': 'application/json',
};

export const httpStatusCode = {
  UNAUTHORIZED: 401,
  NOTFOUND: 404,
};

export class HttpRequest {
  async _request(params = { url: undefined, method: undefined, headers: undefined, body: undefined, responseType: 'json' }) {
    try {
      return await fetch(params.url, params)
        .then(response => {
          if (response.status === httpStatusCode.UNAUTHORIZED) {
            Modal.info({
              title: 'Sua sessão expirou!',
              content: 'Faça o login novamente.'
            });

            window.setTimeout(() => {
              history.push('/login', { previousPage: history.location.pathName });
            }, 2500);
          }
          if (params.responseType === 'blobGet') {
            if (response.status === httpStatusCode.NOTFOUND) {
              return response.json();
            }
            return response.blob();

          }
          else if (params.responseType === 'blob') {
            return response.blob();

          } else {
            return response.json();
          }
        })
    } catch (e) {
      console.log(e)
    }
  }

  async get(url, headers = {}) {
    const params = {
      url,
      method: 'GET',
      headers: { ...defaulHeaders, ...headers }
    };

    return await this._request(params);
  }

  async getFile(url, headers = {}) {
    const params = {
      url,
      method: 'GET',
      headers: { ...defaulHeaders, ...headers },
      responseType: 'blobGet',
    };

    return await this._request(params);
  }

  async post(url, body = {}, headers = {}) {
    const params = {
      url,
      method: 'POST',
      headers: { ...defaulHeaders, ...headers },
    };

    if (body) {
      params.body = JSON.stringify(body);
    }

    return await this._request(params);
  }

  async postBlobResponse(url, body = {}, headers = {}) {
    const params = {
      url,
      method: 'POST',
      headers: { ...defaulHeaders, ...headers },
      responseType: 'blob',
    };

    if (body) {
      params.body = JSON.stringify(body);
    }

    return await this._request(params);
  }

  async postFile(url, body = {}, headers = {}) {
    const params = {
      url,
      method: 'POST',
      headers: { ...headers },
    };

    params.body = body;

    return await this._request(params);
  }

  async put(url, body = {}, headers = {}) {
    const params = {
      url,
      method: 'PUT',
      headers: { ...defaulHeaders, ...headers },
      body: JSON.stringify(body),
    };
    return await this._request(params);
  }

  async authGet(url, headers = {}) {
    const storageInfo = LocalstorageService.getData(narAppStorageKey);
    if (storageInfo) {
      headers.Authorization = `Bearer ${LocalstorageService.getData(narAppStorageKey)['token']}`;
    }
    return this.get(url, headers);
  }

  async authGetFile(url, headers = {}) {
    headers.Authorization = `Bearer ${LocalstorageService.getData(narAppStorageKey)['token']}`;
    return this.getFile(url, headers);
  }

  async authPost(url, body = {}, headers = {}) {
    headers.Authorization = `Bearer ${LocalstorageService.getData(narAppStorageKey)['token']}`;
    return this.post(url, body, headers);
  }

  async authPut(url, body = {}, headers = {}) {
    headers.Authorization = `Bearer ${LocalstorageService.getData(narAppStorageKey)['token']}`;
    return this.put(url, body, headers);
  }

  async authPostFile(url, body = {}, headers = {}) {
    headers.Authorization = `Bearer ${LocalstorageService.getData(narAppStorageKey)['token']}`;
    return this.postFile(url, body, headers);
  }

  authPostBlobResponse(url, body = {}, headers = {}) {
    headers.Authorization = `Bearer ${LocalstorageService.getData(narAppStorageKey)['token']}`;
    return this.postBlobResponse(url, body, headers);
  }
}

export default new HttpRequest();
